import {Stack, Text} from "@mantine/core";
import {
    FEATURE_BUNDLES,
    FeatureBundleKey,
    useFeatureMask,
} from "../../../../featureFlags/featureFlags";
import {FeatureBundleToggle} from "./FeatureBundleToggle";
import classes from "./FeatureToggleGroup.module.css";

/**
 * Tinted box grouping related feature toggles under a small-caps title.
 * Purely presentational: which bundles, which tint, and the order are
 * decided by the caller (SettingsPage) — the feature registry stays
 * presentation-free. Renders nothing when the user may toggle none of the
 * bundles, so an empty tinted box never appears.
 */
export function FeatureToggleGroup({
    title,
    tint,
    bundleKeys,
}: {
    title: string;
    tint: "blue" | "green" | "orange";
    bundleKeys: FeatureBundleKey[];
}) {
    const {canToggle} = useFeatureMask();

    if (!bundleKeys.some((key) => canToggle(FEATURE_BUNDLES[key].mask))) {
        return null;
    }

    return (
        <Stack gap={0} className={`${classes.group} ${classes[tint]}`}>
            <Text className={classes.title}>{title}</Text>
            {bundleKeys.map((key) => (
                <FeatureBundleToggle key={key} bundleKey={key} />
            ))}
        </Stack>
    );
}
